/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bioMatrixScan.vue?vue&type=template&id=5111609e&scoped=true"
import script from "./bioMatrixScan.vue?vue&type=script&lang=js"
export * from "./bioMatrixScan.vue?vue&type=script&lang=js"
import style1 from "./bioMatrixScan.vue?vue&type=style&index=1&id=5111609e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5111609e",
  null
  
)

export default component.exports